import React from 'react';

function PreviewsPdf({ docPDF, title, minHeight = '500px', isLocal = false }) {
  return (
    <object
      style={{ minHeight }}
      data={docPDF}
      height="100%"
      width="100%"
      aria-label={`Preview PDF ${title}`}
    />
  );
}

export default PreviewsPdf;
